import api from "@/utils/api";
import { WHATSAPP_OPTIN } from "@/config/company";

/** Unticked-by-default WhatsApp consent checkbox for booking, sign-up and enquiry forms. */
export default function WhatsAppOptIn({ checked, onChange, testId = "whatsapp-optin" }) {
  return (
    <label className="flex items-start gap-2.5 text-xs text-slate-600 leading-relaxed cursor-pointer" data-testid={`${testId}-label`}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 accent-[#25D366]"
      />
      <span>{WHATSAPP_OPTIN.text}</span>
    </label>
  );
}

/** Save the tick, its time and the exact wording shown. Never throws: consent saving must not break a booking or sign-up. */
export async function saveWhatsAppConsent({ phone, consent, source, name, email }) {
  if (!consent || !phone) return false;
  try {
    await api.post("/v2/whatsapp-consent", {
      phone, consent: true, source, name, email,
      wording: WHATSAPP_OPTIN.text, wording_version: WHATSAPP_OPTIN.version,
    });
    return true;
  } catch {
    return false;
  }
}
